import Fetch from './Fetch'

class Queue {
	fetch = null

	static {
		this.fetch = new Fetch()
	}

	static get() {
		this.fetch.endpoint = 'queue'
		this.fetch.method = 'GET'
		return this.fetch.performRequest()
	}
}

export default Queue
